const disclaimerCont = {
  textKit: '*Este es un ',
  textKit2: ', tu ortodoncista moons lo confirmará en una videollamada al tomar tus impresiones con tu kit en casa',
  textAppnt: '*Este es un ',
  textAppnt2: ', tu ortodoncista moons lo confirmará en cita con tu escaneo 3D de sonrisa',
  bold: 'prediagnóstico'
}

export default disclaimerCont
